// Farbschema: automatisch (Gerät), hell oder dunkel.
// Die Wahl liegt lokal, damit sie ohne Serverfrage sofort greift; das Profil
// merkt sie sich zusätzlich, damit ein zweites Gerät gleich aussieht.
export type Theme = 'auto' | 'light' | 'dark';

const KEY = 'speis_theme';

export function currentTheme(): Theme {
  const stored = localStorage.getItem(KEY);
  return stored === 'light' || stored === 'dark' ? stored : 'auto';
}

/** Tatsächlich sichtbares Schema (auto aufgelöst). */
export function effectiveTheme(theme: Theme = currentTheme()): 'light' | 'dark' {
  if (theme !== 'auto') return theme;
  return matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === 'auto') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', theme);

  localStorage.setItem(KEY, theme);
  syncMetaColor();
}

/** Die Statusleiste des Systems soll zur Kopfzeile passen. */
function syncMetaColor(): void {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (!meta) return;
  const bg = getComputedStyle(document.documentElement).getPropertyValue('--bg').trim();
  if (bg) meta.setAttribute('content', bg);
}

export function initTheme(): void {
  applyTheme(currentTheme());
  // Wechselt das Gerät das Schema, folgt „auto" sofort mit.
  matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (currentTheme() === 'auto') syncMetaColor();
  });
}

export function nextTheme(theme: Theme): Theme {
  return theme === 'auto' ? 'light' : theme === 'light' ? 'dark' : 'auto';
}

export const THEME_LABEL: Record<Theme, string> = {
  auto: 'Automatisch',
  light: 'Hell',
  dark: 'Dunkel',
};
